export const tryParse = <TValue, TReturn = unknown>(value: TValue): TReturn | TValue => {
  if (typeof value !== 'string') {
    return value;
  }
  try {
    return JSON.parse(value) as TReturn | TValue;
  } catch {
    return value;
  }
};
